module.exports = __webpack_public_path__ + "img/chokorin2.248e8aed.png";